import { Injectable } from '@angular/core';
import { ApiService } from '@core/api.service';
import { EmployeesService } from '@features/employees/employees.service';
import { IProject } from '@shared/interfaces/entity/project.interface';
import { CrudService } from 'collection';
import { GetEntityModel } from 'collection';
import { Collection, CollectionModel, Item, ItemModel } from 'collection';
import { BehaviorSubject, Observable } from 'rxjs';
import { BreadcrumbService } from 'xng-breadcrumb';

@Injectable({ providedIn: 'root' })
export class ProjectsService {
  getProjectIdRequest: GetEntityModel;
  getSubProjectIdRequest: GetEntityModel;
  collection: CollectionModel<IProject>;
  subProjectItem: ItemModel;
  projectsCollection: CollectionModel;
  collectionEmp: CollectionModel;

  constructor(
    private _breadcrumbService: BreadcrumbService,
    private _empService: EmployeesService,
    private _crud: CrudService,
    private _api: ApiService
  ) {
    this.collectionEmp = this._empService.collection;

    this.collection = new Collection<IProject>({
      api: this._crud.createEntity({ name: 'project/list-trigger' }),
      params: {
        expand: 'client,user,total_time_minutes,display_status,subprojects_exist'
      }
    });

    this.projectsCollection = new Collection({
      api: this._crud.createEntity({ name: 'project' }),
      params: {
        expand: 'client,user,total_time_minutes,display_status,subprojects_exist'
      }
    });

    this.projectsCollection.hardReloadAfter.updating = false;
    this.collection.hardReloadAfter.deleting = false;

    this.collection.hardReloadAfter.updating = true;
    this.collection.hardReloadAfter.deleting = true;
    this.collection.loadByScrolling = false;

    this.subProjectItem = new Item({
      api: this._api.projects,
      params: {
        expand: 'client,user,total_time_minutes,subprojects.client,subprojects.display_status'
      }
    });

    this.getProjectIdRequest = this._crud.createGetEntity({ name: 'project/next-id' });
    this.getSubProjectIdRequest = this._crud.createGetEntity({ name: 'project/next-sub-id' });
  }
}
